export const MONTH_SPIN_CONTROL_STEP = 1

export const QA_NAME_MONTH_SPIN_PREV_BTN = 'prevMonth'

export const QA_NAME_MONTH_SPIN_NEXT_BTN = 'nextMonth'
